/**
 * @generated SignedSource<<17b06f0384c0a111059584600212d3c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ResendActivationInput = {
  clientMutationId?: string | null;
  email: string;
};
export type signUpConfirmEmailStep_ResendActivationMutation$variables = {
  input: ResendActivationInput;
};
export type signUpConfirmEmailStep_ResendActivationMutation$data = {
  readonly Auth: {
    readonly resendActivation: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type signUpConfirmEmailStep_ResendActivationMutation = {
  response: signUpConfirmEmailStep_ResendActivationMutation$data;
  variables: signUpConfirmEmailStep_ResendActivationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "ResendActivationPayload",
        "kind": "LinkedField",
        "name": "resendActivation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "signUpConfirmEmailStep_ResendActivationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "signUpConfirmEmailStep_ResendActivationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e6198bf7cc46855499e1a36374f88fc",
    "id": null,
    "metadata": {},
    "name": "signUpConfirmEmailStep_ResendActivationMutation",
    "operationKind": "mutation",
    "text": "mutation signUpConfirmEmailStep_ResendActivationMutation(\n  $input: ResendActivationInput!\n) {\n  Auth {\n    resendActivation(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f23c9fead9e631847a3e5d146168eb6f";

export default node;
